import { fetchRequest } from "@providers/conect";

const verCitasApi = async ( data ) => {
  try {
    const url = `agendawp/citas`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verCitasApi };